import ScaleLoader from 'react-spinners/ScaleLoader';
import React from 'react';

const PlayerSpinner = () => (
  <ScaleLoader
    className="justify-center items-center md:h-screen"
    cssOverride={{ display: 'flex' }}
    color="#D53527"
  />
);

export default PlayerSpinner;
